module.exports = {
      id: "404-robot-usage",
      viewBox: "0 0 280 313",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#404-robot",
      toString: function () {
        return this.url;
      }
    }